import { Component, OnInit } from '@angular/core';
import { User } from 'src/app/model/user.model';
import { UserService } from 'src/app/services/user/user.service';

@Component({
  selector: 'app-uploaddata',
  templateUrl: './uploaddata.component.html',
  styleUrls: ['./uploaddata.component.css']
})
export class UploaddataComponent implements OnInit {

  user: User;
  currentUserImage: any;

  //userSubjects: any;

  avatar: any;


  constructor(private userServices: UserService) {
    this.user = new User;
  }

  ngOnInit() {
  }

  onImageSelect(event) {
    if (event.target.files.length > 0) {
      let file = event.target.files[0];
      this.avatar = file;
      let input = new FormData();
      input.append('avatar', this.avatar);
      input.append('currentUserId', '339e90ac-ac4e-4f94-ad37-ec29a0c02c6d');

      this.userServices.uploadUserData(input).subscribe(
        (data: any) => {
          console.log(data);
        });
    }
  }

}
